import React from 'react';

const SidePanelHeader = (props) => (
    <div className="sidePanelHeader hidden-xs">
        <h4 onClick={() => props.toggle()}>
            {props.title}
        </h4>
    </div>
);


export default SidePanelHeader;


// WEBPACK FOOTER //
// ./src/App/SidePanelHeader.js